import styled from "styled-components";

const SVGIconWrapper = styled.div.attrs(props => {
  const usesMask = props.$color || props.$hoverColor;
  // Default to white if no color is provided, matching previous behavior
  const baseColor = props.$color || "white";
  const hoverColor = props.$hoverColor || baseColor;
  const style = {
    "--base-color": baseColor,
    "--hover-color": hoverColor,
    width: props.$width,
    height: props.$height,
    transform: props.$rotation ? `rotate(${props.$rotation})` : undefined
  };
  if (usesMask && props.$src) {
    style.maskImage = `url(${props.$src})`;
    style.maskSize = "cover";
    style.WebkitMaskImage = `url(${props.$src})`;
    style.WebkitMaskSize = "cover";
  } else if (props.$src) {
    style.backgroundImage = `url(${props.$src})`;
    style.backgroundRepeat = "no-repeat";
    style.backgroundSize = "contain";
  }
  return { style };
})`
  display: inline-block;
  background-color: var(--base-color);
  &:hover {
    background-color: var(--hover-color);
  }
`;

export { SVGIconWrapper };
